<template>
	<div class="qr-page">
		<section class="sec-01">
			<div class="container-box">
				<h2>
					{{ $t('new_ui.personal_qr_page_v2.sec_01.title.one') }}<br />
					{{ $t('new_ui.personal_qr_page_v2.sec_01.title.two') }}
					<strong>
						{{ $t('new_ui.personal_qr_page_v2.sec_01.title.three') }}
					</strong>
				</h2>
				<p>
					{{ $t('new_ui.personal_qr_page_v2.sec_01.desc.one') }}<br />
					{{ $t('new_ui.personal_qr_page_v2.sec_01.desc.two') }}
					<br />
					{{ $t('new_ui.personal_qr_page_v2.sec_01.desc.three') }}
				</p>
				<div class="btn-box">
					<a href="/auth/register" class="btn-type-01">
						{{ $t('new_ui.personal_qr_page_v2.sec_01.btn.one') }}
					</a>
					<a href="/auth/login" class="btn-type-02">
						{{ $t('new_ui.personal_qr_page_v2.sec_01.btn.two') }}
					</a>
				</div>
			</div>
		</section>
		<section class="sec-04">
			<div class="container-box">
				<h3 class="title">
					{{ $t('new_ui.personal_offline_kiosk_page_v2.sec_04.title') }}
				</h3>
				<div class="card-box">
					<div class="card-content card-content-01">
						<div class="txt">
							<h5>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.one.title',
									)
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.one.description.one',
									)
								}}<br />
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.one.description.two',
									)
								}}
							</p>
						</div>
						<img :src="img.iconKiosk01" alt="" />
					</div>
					<div class="card-content card-content-02">
						<div class="txt">
							<h5>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.two.title',
									)
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.two.description.one',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.two.description.two',
									)
								}}
							</p>
						</div>
						<img :src="img.iconKiosk02" alt="" />
					</div>
					<div class="card-content card-content-03">
						<div class="txt">
							<h5>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.three.title',
									)
								}}
							</h5>
							<p>
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.three.description.one',
									)
								}}
								<br />
								{{
									$t(
										'new_ui.personal_offline_kiosk_page_v2.sec_04.cards.three.description.two',
									)
								}}
							</p>
						</div>
						<img :src="img.iconKiosk03" alt="" />
					</div>
				</div>
			</div>
		</section>
		<section class="sec-06">
			<div class="bg-01"></div>
			<div class="bg-02"></div>
			<div class="bg-03"></div>
			<div class="container-box">
				<div class="txt-box">
					<h3 v-if="!isMobile">
						{{ $t('new_ui.personal_qr_page_v2.sec_06.title.one') }}<br />
						<strong>{{
							$t('new_ui.personal_qr_page_v2.sec_06.title.two')
						}}</strong
						>{{ $t('new_ui.personal_qr_page_v2.sec_06.title.three') }}
					</h3>
					<ul class="step-list">
						<li :class="{ active: activeStep === 1 }" @click="setActiveStep(1)">
							<h4>
								{{ $t('new_ui.personal_qr_page_v2.sec_06.step.one.title') }}
							</h4>
							<p class="sub-title">
								{{ $t('new_ui.personal_qr_page_v2.sec_06.step.one.subTitle') }}
							</p>
							<p class="desc">
								{{ $t('new_ui.personal_qr_page_v2.sec_06.step.one.desc.one')
								}}<br />
								{{ $t('new_ui.personal_qr_page_v2.sec_06.step.one.desc.two') }}
							</p>
						</li>
						<li :class="{ active: activeStep === 2 }" @click="setActiveStep(2)">
							<h4>
								{{ $t('new_ui.personal_qr_page_v2.sec_06.step.two.title') }}
							</h4>
							<p class="sub-title">
								{{ $t('new_ui.personal_qr_page_v2.sec_06.step.two.subTitle') }}
							</p>
							<p class="desc">
								{{ $t('new_ui.personal_qr_page_v2.sec_06.step.two.desc.one')
								}}<br />
								{{ $t('new_ui.personal_qr_page_v2.sec_06.step.two.desc.two') }}
							</p>
						</li>
						<li :class="{ active: activeStep === 3 }" @click="setActiveStep(3)">
							<h4>
								{{ $t('new_ui.personal_qr_page_v2.sec_06.step.three.title') }}
							</h4>
							<p class="sub-title">
								{{
									$t('new_ui.personal_qr_page_v2.sec_06.step.three.subTitle')
								}}
							</p>
							<p class="desc">
								{{ $t('new_ui.personal_qr_page_v2.sec_06.step.three.desc.one')
								}}<br />
								{{
									$t('new_ui.personal_qr_page_v2.sec_06.step.three.desc.two')
								}}
							</p>
						</li>
					</ul>
				</div>
				<div class="img-box">
					<img :src="img.imgQrSec06" alt="" />
					<div class="scan" :class="{ scanning: isScanning }">
						<span></span>
					</div>
				</div>
				<h3 v-if="isMobile">
					{{ $t('new_ui.personal_qr_page_v2.sec_06.title.one') }}<br />
					<strong>{{
						$t('new_ui.personal_qr_page_v2.sec_06.title.two')
					}}</strong
					>{{ $t('new_ui.personal_qr_page_v2.sec_06.title.three') }}
				</h3>
			</div>
		</section>
		<section class="sec-07">
			<div class="container-box">
				<h3>
					{{ $t('new_ui.personal_qr_page_v2.sec_07.title.one') }}<br />{{
						$t('new_ui.personal_qr_page_v2.sec_07.title.two')
					}}
				</h3>
				<p>
					{{ $t('new_ui.personal_qr_page_v2.sec_07.desc.one') }}<br />
					{{ $t('new_ui.personal_qr_page_v2.sec_07.desc.two') }}
					<br />
					{{ $t('new_ui.personal_qr_page_v2.sec_07.desc.three') }}
				</p>
			</div>
		</section>
	</div>
</template>

<script>
import imgKioskStep01 from '@/assets/images/v2/img-kiosk-step-01.png';
import imgKioskStep02 from '@/assets/images/v2/img-kiosk-step-02.png';
import imgKioskStep03 from '@/assets/images/v2/img-kiosk-step-03.png';
import imgQrSec06 from '@/assets/images/v2/img-qr-sec-06.png';
import iconKiosk01 from '@/assets/images/v2/icon/icon-kiosk-01.svg';
import iconKiosk02 from '@/assets/images/v2/icon/icon-kiosk-02.svg';
import iconKiosk03 from '@/assets/images/v2/icon/icon-kiosk-03.svg';

export default {
	data() {
		return {
			mobile: false,
			activeStep: 1,
			isScanning: false,
			img: {
				imgKioskStep01,
				imgKioskStep02,
				imgKioskStep03,
				iconKiosk01,
				iconKiosk02,
				iconKiosk03,
				imgQrSec06,
			},
		};
	},
	computed: {
		isMobile() {
			return this.mobile;
		},
	},
	mounted() {
		this.checkMobile();
		window.addEventListener('resize', this.checkMobile);
	},
	beforeUnmount() {
		window.removeEventListener('resize', this.checkMobile);
	},
	methods: {
		checkMobile() {
			this.mobile = window.innerWidth <= 768;
		},
		setActiveStep(step) {
			this.activeStep = step;

			// step 2 클릭 시 스캔 애니메이션 실행
			if (step === 2) {
				this.startScanAnimation();
			} else {
				this.isScanning = false;
			}
		},
		startScanAnimation() {
			this.isScanning = true;

			// 3초 후 애니메이션 정지
			setTimeout(() => {
				this.isScanning = false;
			}, 3000);
		},
	},
};
</script>
